<template>
  <div
    id="kt_header"
    class="header"
    data-kt-sticky="true"
    data-kt-sticky-name="header"
    data-kt-sticky-offset="{default: '200px', lg: '300px'}"
  >
    <!--begin::Container-->
    <div class="container-xxl d-flex flex-grow-1 flex-stack" >
      <!--begin::Header Logo-->
      <div class="d-flex align-items-center me-5">
        <!--begin::Heaeder menu toggle-->
        <v-icon v-if="showNavBtn" id="navMenuBtn" @click="$emit('showNavDrawer')">mdi-menu</v-icon>
        <!--end::Heaeder menu toggle-->
        <router-link :to="{ name: 'Landing' }">
          <img
            alt="Logo"
            src="@/assets/media/logos/PYBLogo.png"
            class="h-80px mainlogo"
          />
        </router-link>
      </div>
      <!--end::Header Logo-->
      <!--begin::Topbar-->
      <div class="d-flex align-items-center">
        <!--begin::Topbar-->
        <AuthDropdown
            :reload="reload"
            @reset="reset"
            @showNotifier="showNotifier"
          />
        <!--end::Topbar-->
      </div>
      <!--end::Topbar-->
    </div>
    <!--end::Container-->
    <!--begin::Separator-->
    <div class="separator"></div>
    <!--end::Separator-->
  </div>
</template>

<script>
import mixins from "vue-typed-mixins";
import UserMixin from "@/mixins/UserMixin";
import ScreenMixin from "@/mixins/ScreenMixin";
import AuthDropdown from "@/components/AuthDropdown.vue";

export default mixins(ScreenMixin, UserMixin).extend({
  name: "Header",
  components: {
    AuthDropdown,
  },
  props: {
    reload: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    };
  },
  methods: {
    reset(e){
        this.$emit('reset', e);
    },
    showNotifier(e){
      this.$emit('showNotifier', e);
    }
  },
  computed: {
    showNavBtn(){
      if(this.onLandingPage) return this.hideLandingHeaderBtn
      return this.hideUserDropdownBtn;
    },
    onLandingPage(){
      return this.$route.name === 'Landing';
    },
    hideLandingHeaderBtn(){
      return this.screenWidth < 720;
    },
    hideUserDropdownBtn(){
      return this.screenWidth < 545;
    }
  }
});
</script>

<style>
#kt_header_user_menu_toggle__BV_toggle_{
  padding-right: 0px;
}
._dropdown-items{
  overflow: scroll;
  max-height: 70vh;
}
#navMenuBtn:hover{
  color: #0A31A2;
  cursor: pointer;
}


</style>
